
let config = {};
let environment = "live";
if (environment == "local") {
  config = {
    frontendurl: "http://localhost:3001",
    adminBackendUrl: "http://localhost:8080/adminApi/",
    BNB_URL: "https://testnet.bscscan.com",
    TEXA_URL: "https://texascan.texaforce.com/tx/",
    SECURITY_KEY : "DfrtFDF4657@#2*?HGHtJU"
    // TEXA_URL: "https://texascanapi.texaforce.com/tx/",
  };
} else if (environment == "staging") {
  config = {
    frontendurl: "https://stagingadminpanel.texaforce.com",
    adminBackendUrl: "https://stagingapi.texaforce.com/adminApi/",
    BNB_URL: "https://testnet.bscscan.com",
    TEXA_URL: "https://texascan.texaforce.com/tx/",
    SECURITY_KEY : "DfrtFDF4657@#2*?HGHtJU"
    // TEXA_URL: "https://texascanapi.texaforce.com/tx/"
  };
} else {
  config = {
    frontendurl: "https://adminpanel.texaforce.com",
    adminBackendUrl: "https://api.texaforce.com/adminApi/",
    BNB_URL: "https://bsc-dataseed1.binance.org",
    TEXA_URL: "https://texascan.texaforce.com/tx/",
    SECURITY_KEY : "DfrtFDF4657@#2*?HGHtJU"
    // TEXA_URL: "https://texascanapi.texaforce.com/tx/"
  };
}

export default config;



